import {Injectable} from "@angular/core";
import {HttpClientService} from "../httpClient/httpclient.service";
import {
  AreaModel, CardModeModel, ClusterModel, DateListModel, GroupModel, GroupTypeModel,
  StoreComboModel
} from "./analytics.model";
import {DatePipe} from "@angular/common";
import { CustomerBaseGroup } from "../../models/customer-campaign.model";

@Injectable()
export class AnalyticsService {
  cluster_list: ClusterModel[];
  card_modes: CardModeModel[];
  date_list: DateListModel;
  date_commercial_list: DateListModel;
  date_customer_shopping_habits: DateListModel;
  group_types: CustomerBaseGroup[];
  group_types_formatted: GroupTypeModel[];

  groups: GroupModel[];
  areas: AreaModel[];
  stores_combo: StoreComboModel[];

  selectedStartDate: Date;
  selectedEndDate: Date;

  public baseUrl = 'koncentro-analytics';

  constructor (private h: HttpClientService,
               private datePipe: DatePipe
               ) {

  }

  /**
   * Restituisce la lista dei Cluster
   */
  getClusterList() {
    return this.h.get(`/${this.baseUrl}/analytics/common/cluster_list`)
      .map(res => {
        return this.cluster_list = res;
      })
  }

  /**
   * Restituisce i possibili stati della Carta
   */
  getCardModes() {
    return this.h.get(`/${this.baseUrl}/analytics/common/card_modes`)
      .map(res => {
        return this.card_modes = res;
      })
  }

  /**
   * Restituisce elenco possibili Date di Inizio e di Fine per i filtri
   */
  getDates() {
    return this.h.get(`/${this.baseUrl}/analytics/common/dates`)
      .map(res => {
        this.date_list = new Map()
        for (let start_key in res) {
          let end_dates: Date[] = [];
          res[start_key].forEach(ends => {
            end_dates.push(new Date(ends))
          })
          this.date_list.set(new Date(start_key), end_dates);
        }
        return this.date_list;
      })
  }

  newGetDates() {
    return this.h.get(`/${this.baseUrl}/analytics/getCSumDates`).map(res => {
      /* tratto la response come in getDates (chiamata usata precedentemente per popolare i campi relativi a
      data inizio e fine di Panoramica Clienti) per non dover ricostruire tutta la UI */
      this.date_list = new Map();
      this.date_list.set(new Date(res[0]['data_inizio']), [new Date(res[0]['data_fine'])]);
      return this.date_list;
    })
  }

  /**
   * Restituisce i Tipi di Gruppo
   */
  getGroupTypes() {
    return this.h.get(`/${this.baseUrl}/analytics/base_groups`)
      .map(res => {
        return this.group_types = res;
      })
  }

  getGroupTypesFormatted() {
    return this.getGroupTypes()
      .map(res => {
        this.group_types_formatted = []
        res.forEach(gt => {
          this.group_types_formatted.push({
            type: gt.group,
            code: gt.key_code_group,
            description: gt.key_desc_group,
            groups: gt.subgroups
          })
        })
        return this.group_types_formatted;
      })
  }

  /**
   * Restituisce elenco possibili Date di Inizio e di Fine per i filtri
   * @param raggruppamento
   * @param finestra
   */
  getVaDates(raggruppamento: string, finestra: string) {
    if(raggruppamento == null || finestra == null) {
      return this.newGetDates();
    }

    let urlQuerySting = '';
    if (finestra) {
      urlQuerySting += 'finestra=' + finestra;
    }

    if (raggruppamento) {
      if (urlQuerySting !== '') { urlQuerySting += '&'; }
      urlQuerySting += 'raggruppamento=' + raggruppamento;
    }

    const url = urlQuerySting !== '' ?
      `/${this.baseUrl}/analytics/getVaDates?` + urlQuerySting :
      `/${this.baseUrl}/analytics/getVaDates` ;



/*
    const url = raggruppamento == null ?
                `/${this.baseUrl}/analytics/getVaDates?finestra=` + finestra :
                `/${this.baseUrl}/analytics/getVaDates?raggruppamento=` + raggruppamento + '&finestra=' + finestra;
*/

    return this.h.get(url).map(res => {
        this.date_list = new Map()
        for(let idx: number = 0; idx < res.length; idx++) {
          let obj = res[idx];
          let startDate: Date = new Date(obj.data_inizio);

          if(!this.date_list.has(startDate)) {
            this.date_list.set(startDate, [])
          }

          for(let i=idx; i < res.length; i++) {
            let endDate: Date = new Date(res[i].data_fine);
            this.date_list.get(startDate).push(endDate);
          }
        }
        return this.date_list;
      })
  }

  getVaDatesPromo(raggruppamento: string, finestra: string) {

    let urlQuerySting = '';
    if (raggruppamento) {
      urlQuerySting += 'raggruppamento=' + raggruppamento;
    }
    if (finestra) {
      if (urlQuerySting !== '') { urlQuerySting += '&'; }
      urlQuerySting += 'finestra=' + finestra;
    }

    console.log("QUERYSTRING :: ", urlQuerySting);

    const url = urlQuerySting !== '' ?
      `/${this.baseUrl}/analytics/getVaDatesPromo?` + urlQuerySting :
      `/${this.baseUrl}/analytics/getVaDatesPromo` ;

    return this.h.get(url).map(res => {
      this.date_list = new Map()
      for(let idx: number = 0; idx < res.length; idx++) {
        let obj = res[idx];
        let startDate: Date = new Date(obj.data_inizio);

        if(!this.date_list.has(startDate)) {
          this.date_list.set(startDate, [])
        }

        for(let i=idx; i < res.length; i++) {
          let endDate: Date = new Date(res[i].data_fine);
          this.date_list.get(startDate).push(endDate);
        }
      }
      return this.date_list;
    })
  }

  getVaDatesFinestra(finestra: string) {
    const url = `/${this.baseUrl}/analytics/getVaDates?finestra=` + finestra ;

    return this.h.get(url).map(res => {
        this.date_list = new Map()
        for(let idx: number = 0; idx < res.length; idx++) {
          let obj = res[idx];
          let startDate: Date = new Date(obj.data_inizio);

          if(!this.date_list.has(startDate)) {
            this.date_list.set(startDate, [])
          }

          for(let i=idx; i < res.length; i++) {
            let endDate: Date = new Date(res[i].data_fine);
            this.date_list.get(startDate).push(endDate);
          }
        }
        return this.date_list;
      })
  }

  getSpDates() {
    return this.getDatesByType('getSpDates');
  }

  getCsDates() {
    return this.getDatesByType('getCsDates');
  }

  /**
   * Restituisce elenco possibili Date di Inizio e di Fine per i filtri
   * @param type
   */
  getDatesByType(type: string) {
    return this.h.get(`/${this.baseUrl}/analytics/${type}`)
      .map(res => {

        const tmp_date_list = new Map();
        for (let idx = 0; idx < res.length; idx++) {
          const obj = res[idx];
          const startDate: string = obj.data_inizio;

          if (!tmp_date_list.has(startDate)) {
            tmp_date_list.set(startDate, new Map())
          }

          for (let i = idx; i < res.length; i++) {
            tmp_date_list.get(startDate).set(res[i].data_fine, res[i].data_fine);
          }
        }

        this.date_list = new Map();

        tmp_date_list.forEach((value: Map<string, string>, key: string) => {
          const values: Date[] = [];

          value.forEach((v: string, k: string) => {
            values.push(new Date(k));
          });

          values.sort(function(a, b){
            if (a > b) { return 1; }
            if (a < b) { return -1; }
            return 0;
          });

          this.date_list.set(new Date(key), values);
        });

        console.log(tmp_date_list);
        console.log(this.date_list);

        return this.date_list;
      })
  }

  getDatesCommercial() {
    return this.getVaDatesFinestra("MESE")
      .map(res => {
        // Determinazione selected start date e end date
        let lastYear = 0;
        res.forEach(function (endDates: Date[], startDate: Date) {
          lastYear = Math.max(lastYear, startDate.getFullYear());
        });

        let that = this;
        res.forEach(function (endDates: Date[], startDate: Date) {
          if (startDate.getFullYear() === lastYear) {
            that.selectedStartDate = that.selectedStartDate != null && that.selectedStartDate < startDate ? that.selectedStartDate : startDate;

            endDates.forEach(function(d) {
              that.selectedEndDate = that.selectedEndDate != null && that.selectedEndDate > d ? that.selectedEndDate : d;
            });
          }
        });

        this.date_commercial_list = res;

        console.log(this.date_commercial_list);
        return this.date_commercial_list;
      });
  }

  getDatesCustomerShoppingHabits() {
    return this.h.get(`/${this.baseUrl}/analytics/common/dates_customers_shopping_habits`)
      .map(res => {
        this.date_customer_shopping_habits = new Map()
        for (let start_key in res) {
          let end_dates: Date[] = [];
          res[start_key].forEach(ends => {
            end_dates.push(new Date(ends))
          })
          this.date_customer_shopping_habits.set(new Date(start_key), end_dates);
        }
        return this.date_customer_shopping_habits;
      })
  }

  getGroupList() {
    return this.h.get(`/${this.baseUrl}/analytics/common/groups`)
      .map(res => {
        return this.groups = res;
      })
  }

  /**
   * Restituisce elenco Aree Geografiche
   */
  getAreaList() {
    return this.h.get(`/${this.baseUrl}/analytics/common/areas`)
      .map(res => {
        return this.areas = res;
      })
  }

  /**
   * Restituisce lista delle Combo di Negozi
   */
  getStoreComboList() {
    return this.h.get(`/${this.baseUrl}/analytics/common/stores_combo`)
      .map(res => {
        return this.stores_combo = res;
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/services/analytics/analytics.service.ts